import React, { FC, useEffect, useRef, useState } from "react";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography from "@insite/mobius/Typography";
import translate from "@insite/client-framework/Translate";
import styled, { css } from 'styled-components';
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ADIColors from "@NA/Utils/ADIColors";

export interface ADIDeviceRotateStyles {
    iphoneChromeLandscape?: GridContainerProps;
    iponeChromeInnerrWidth?: GridContainerProps;
    innerContainer?: InjectableCss;
    landscapeTitle?: InjectableCss;
    landscapeContent?: InjectableCss;
    landscapeApp?: InjectableCss;
}
export const deviceRotateStyles: ADIDeviceRotateStyles = {
    iphoneChromeLandscape: {
        css: css`
            position: fixed;
            display: flex;
            justify-content: center;
            align-items: center;
            background: linear-gradient(51deg, #002856, #2d5787 82%);
            color: ${ADIColors.white};
            width: 100%;
            top: 0;
            left: 0;
            height: 100vh;
            text-align: center;
            z-index: 999999;
            
            &.Iphone-Chrome-Landscape {
                @media (min-width: 375px) {
                        display: none;
                    }
                    @media only screen and (min-device-width : 375px) and (max-device-width : 1024px) and (orientation : landscape) {
                        display: block;
                    }
                }
                
            `,
    },
    iponeChromeInnerrWidth: {
        css: css`
        position: absolute;
        transform: translate(-50%, -50%);
        top: 50%;
        left: 50%;
        width: 100%;
        height: 99%;
        justify-content: center;
        align-items: center;
        display: flex;
        flex-direction: column;
        &.Ipone-Chrome-InnerrWidth{
          @media (max-width: 1080px) {
                zoom: .5;
            }
        }  
        `,
    },
    landscapeTitle: {
        css: css`
        padding: 15px 0 0;
        font-size: 20px;
        font-weight: bold;
        line-height: 1.3;
        margin-bottom: 1.25rem;
        `,
    },
    landscapeContent: {
        css: css`
        font-size: 14px;
        line-height: 1.43;
        margin-bottom: 1.25rem;
        `,
    },
    landscapeApp: {
        css: css`
        font-size: 14px;
        font-weight: bold;
        line-height: 1.57;
        margin-bottom: 1.25rem;
        `,
    },
};
const styles = deviceRotateStyles;
const LandscapeMessage: React.FC = () => {
    const [isLandscape, setIsLandscape] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
    // Detect if the device is mobile (Android, iOS, iPad, etc.)
    const userAgent = window.navigator.userAgent;
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && isTouchDevice;
    const isAndroid = /Android/.test(userAgent) && isTouchDevice;
    const isMobileDevice = isIOS || isAndroid;
    setIsMobile(isMobileDevice);

    const handleOrientationChange = () => {
        const screenWidth = window.innerWidth;
        const isLandscapeMode = window.matchMedia("(orientation: landscape)").matches;

        // If the device is mobile and in landscape mode with a screen width less than 1080px
        if (isLandscapeMode && isMobileDevice && screenWidth < 1080) {
        setIsLandscape(true);
        } else {
        setIsLandscape(false);
        }
    };

    // Initial check
    handleOrientationChange();

    // Add resize event listener
    window.addEventListener('resize', handleOrientationChange);

    // Clean up the event listener on unmount
    return () => {
        window.removeEventListener('resize', handleOrientationChange);
    };
    }, []);

    return (
        <>
            {isLandscape ? (
                <StyledWrapper {...styles.iphoneChromeLandscape} className="Iphone-Chrome-Landscape">
                    <StyledWrapper {...styles.iponeChromeInnerrWidth} className="Ipone-Chrome-InnerrWidth">
                        <img alt="Landscape Device Rotate" src="https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/landscape-device-rotate.png" />
                        <Typography {...styles.landscapeTitle}>{translate("Please rotate your device")}</Typography>
                        <Typography {...styles.landscapeContent}>{translate("Landscape mode is not supported. Please return to portrait mode for a better experience.")}</Typography>
                        <Typography {...styles.landscapeApp}>{translate("(Or, better yet, download our app from the APP Store!)")}</Typography>
                    </StyledWrapper>
                </StyledWrapper>
            ) : null}
        </>
    );
};


const widgetModule: WidgetModule = {
    component: LandscapeMessage,
    definition: {
        group: "Common",
        displayName: "ADI Rotate Device to Landscape",
    },
};

export default widgetModule;
